import { useEffect, useState } from 'react'
import CreateNewPractice from 'src/consumer/components/TimerComponent/CongratulatoryFlow/AddPractice/CreateNew/CreateNewPractice'
import { TIMERS_OBJECT_EMPTY } from 'src/consumer/components/TimersPage/utils'

export default function TimerAddEditDialog({ timerToEdit, refreshFunction }) {
  const [formTimer, setFormTimer] = useState({ ...TIMERS_OBJECT_EMPTY, title: '' })

  function setTitle(newValue) {
    setFormTimer((prevTimer) => ({
      ...prevTimer,
      title: newValue,
    }))
  }

  function setDurationType(newValue) {
    setFormTimer((prevTimer) => ({
      ...prevTimer,
      durationType: newValue,
    }))
  }

  function setBellType(newValue) {
    setFormTimer((prevTimer) => ({
      ...prevTimer,
      bellType: newValue,
    }))
  }

  function setDuration(prevNewVal) {
    setFormTimer((prevTimer) => ({
      ...prevTimer,
      duration: prevNewVal(prevTimer?.duration),
    }))
  }

  function setMaxDuration(prevNewVal) {
    setFormTimer((prevTimer) => ({
      ...prevTimer,
      maxDuration: prevNewVal(prevTimer?.maxDuration),
    }))
  }

  function setIntervals(prevNewVal) {
    const isFunction = typeof prevNewVal === 'function'
    if (isFunction) {
      setFormTimer((prevTimer) => ({
        ...prevTimer,
        intervals: prevNewVal(prevTimer?.intervals || []),
      }))
    } else {
      setFormTimer((prevTimer) => ({
        ...prevTimer,
        intervals: prevNewVal,
      }))
    }
  }

  function setReminderTime(prevNewVal) {
    if (typeof prevNewVal === 'function') {
      setFormTimer((prevTimer) => ({
        ...prevTimer,
        preferredTimes: prevNewVal(prevTimer?.preferredTimes),
      }))
    } else {
      setFormTimer((prevTimer) => ({
        ...prevTimer,
        preferredTimes: prevNewVal,
      }))
    }
  }

  useEffect(() => {
    if (timerToEdit) {
      setFormTimer(timerToEdit)
    }
  }, [timerToEdit])

  return (
    <CreateNewPractice
      title={formTimer?.title}
      intervals={formTimer?.intervals}
      timerType={formTimer?.durationType}
      bellType={formTimer?.bellType}
      duration={formTimer?.duration}
      maxDuration={formTimer?.maxDuration}
      reminderTime={formTimer?.preferredTimes}
      setBellType={setBellType}
      setDuration={setDuration}
      setMaxDuration={setMaxDuration}
      setIntervals={setIntervals}
      setTitle={setTitle}
      setTimerType={setDurationType}
      setReminderTime={setReminderTime}
      backToPreviousPage={refreshFunction}
      timerId={formTimer?.id}
    />
  )
}
